import React from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">Create a photo library that connects your memories.</h1>
        <p className="hero-subtitle">MyPictor offers an AI-powered photo library where you can organize, search, and rediscover your most precious moments.</p>
        <Link to="/download" className="cta-button">
          Download
        </Link>
      </div>
    </section>
  );
}
